import { useFormikContext } from 'formik'
import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { FAKE_EVENT_UUID } from '../../utils/constants/eventTypeForms'
import eventVariantType from '../../types/events/eventVariantType'
import eventRawType from '../../types/events/eventRawType'

const AutoChangeFakeEvent = (props) => {
  const { clickedEventId, selectedEventType, eventsRaw, setEvents } = props
  const { values } = useFormikContext()
  const { title, startDateTime, endDateTime, fromDate, startTime, endTime, teams, type } = values

  // Track previous values to avoid unnecessary updates
  const prevValuesRef = useRef({
    title,
    startDateTime,
    endDateTime,
    fromDate,
    startTime,
    endTime,
    teamsId: teams?.[0]?.id || teams?.id,
    typeName: type?.name,
  })

  useEffect(() => {
    const eventId = clickedEventId || FAKE_EVENT_UUID
    const fakeEvent = eventsRaw && eventsRaw.filter((value) => value.uuid === eventId)

    // Check if any relevant values actually changed
    const currentTeamsId = teams?.[0]?.id || teams?.id
    const currentTypeName = type?.name
    const hasChanged =
      title !== prevValuesRef.current.title ||
      startDateTime !== prevValuesRef.current.startDateTime ||
      endDateTime !== prevValuesRef.current.endDateTime ||
      fromDate !== prevValuesRef.current.fromDate ||
      startTime !== prevValuesRef.current.startTime ||
      endTime !== prevValuesRef.current.endTime ||
      currentTeamsId !== prevValuesRef.current.teamsId ||
      currentTypeName !== prevValuesRef.current.typeName

    if (!hasChanged) {
      return
    }

    prevValuesRef.current = {
      title,
      startDateTime,
      endDateTime,
      fromDate,
      startTime,
      endTime,
      teamsId: currentTeamsId,
      typeName: currentTypeName,
    }

    if (
      fakeEvent &&
      fakeEvent[0] &&
      ((title !== fakeEvent[0].title && title !== '') ||
        startDateTime !== fakeEvent[0].startDateTime ||
        endDateTime !== fakeEvent[0].endDateTime ||
        fromDate !== fakeEvent[0].startDateTime ||
        startTime !== fakeEvent[0].startDateTime ||
        endTime !== fakeEvent[0].startDateTime ||
        type?.name !== selectedEventType.name)
    ) {
      const newEventsRaw = eventsRaw.filter(function (value) {
        return value.uuid !== eventId
      })

      const createTitle = () => {
        if (clickedEventId) {
          return eventsRaw.filter((event) => event.uuid === clickedEventId)[0].title
        } else {
          if (title && selectedEventType.name === 'LIVE_STREAM') {
            return title
          } else {
            return `NEW ${selectedEventType.name}`
          }
        }
      }

      setEvents([
        ...newEventsRaw,
        {
          uuid: eventId,
          type: {
            displayName: selectedEventType,
            color: selectedEventType.color,
          },
          title: createTitle(),
          timeZone: 'Europe/Athens',
          startDateTime: startTime ?? startDateTime,
          endDateTime: endTime ?? endDateTime,
          teams: [
            {
              name: teams?.[0] ? teams[0].name : 'TM',
              uuid: teams?.[0] ? teams[0].id : FAKE_EVENT_UUID,
              threeLetterIdentifier: teams?.[0] ? teams[0].threeLetterIdentifier : '',
            },
          ],
        },
      ])
    }
  }, [title, startDateTime, endDateTime, fromDate, startTime, endTime, teams, type, selectedEventType, clickedEventId, eventsRaw, setEvents])

  return null
}

AutoChangeFakeEvent.propTypes = {
  clickedEventId: PropTypes.string,
  selectedEventType: eventVariantType,
  eventsRaw: PropTypes.arrayOf(eventRawType),
  setEvents: PropTypes.func,
}

export default AutoChangeFakeEvent
